import axios from 'axios';
import LocalStorage from 'local-storage';
import tokenRenewalService from './tokenrenewal.service';
import { logoutAfterSessionExpiry } from '../utils/sessionExpiredLogout';

let _CurrentLoggedInUser = null;
let _UserToken = '';
let _IsReDirect = '0';
class AppCache {
    constructor() {
        this.sessionTimeout = 20 * 60 * 1000;
        this.sessionTimer = null;
        this.activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll'];

        this.startSessionTimer = () => {
            this.sessionTimer = setTimeout(this.clearStorage, this.sessionTimeout);
        };

        this.resetSessionTimer = () => {
            clearTimeout(this.sessionTimer);
            this.startSessionTimer();
        };

        this.clearStorage = () => {
            console.log('Session expired');
            tokenRenewalService.stop();
            logoutAfterSessionExpiry(async () => {
                try {
                    const { default: logoutService } = await import('./logout.service');
                    const LogoutServiceInstance = await logoutService;
                    await LogoutServiceInstance.Logout();
                } finally {
                    _CurrentLoggedInUser = null;
                    LocalStorage.clear();
                }
            });
        };

        this.clearStorageOnRefresh = () => {
            tokenRenewalService.stop();
            _CurrentLoggedInUser = null;
            LocalStorage.clear();
            sessionStorage.clear();
            window.location.href = '/login';
        };


        this.handleUserActivity = () => {
            this.resetSessionTimer();
        };
        this.activityEvents.forEach(event => {
            document.addEventListener(event, this.handleUserActivity);
        });
        this.startSessionTimer();


        // Log out on an actual browser refresh. The previous localStorage flag
        // could be cleared by other startup flows before it was checked.
        const distributorPattern = /^\/DistributorClaimApproval\/[^/]+\/\d+$/;
        const emailApprovalPattern = /^\/ContractClaimApproval\/[^/]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\/\d+$/;
        const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
        const isBrowserRefresh = navigationEntry?.type === 'reload'
            || performance.navigation?.type === performance.navigation?.TYPE_RELOAD;
        const isRefreshLogoutExempt = distributorPattern.test(window.location.pathname)
            || emailApprovalPattern.test(window.location.pathname)
            || window.location.pathname === '/login';

        if (isBrowserRefresh && !isRefreshLogoutExempt) {
            this.clearStorageOnRefresh();
        }
        this.RemoveItemFromLocalStorage = () => {

            LocalStorage.remove("_IsReDirect")
        }

        this.GetIsRedirect = () => {
            _IsReDirect = LocalStorage.get("_IsReDirect");
            if (_IsReDirect === null)
                _IsReDirect = '0'
            return _IsReDirect;
        };

        this.SetIsRedirect = (IsRedirect) => {
            _IsReDirect = IsRedirect;
            LocalStorage.set("_IsReDirect", _IsReDirect);
        }
        this.GetCurrentLoggedInUser = () => {
            if (_CurrentLoggedInUser === null)
                _CurrentLoggedInUser = LocalStorage.get("_CurrentLoggedInUser");
            return _CurrentLoggedInUser;
        };


        this.SetCurrentLoggedInUser = (token) => {
            const CurrentLoggedInUser = {
                Token: token
            }

            _CurrentLoggedInUser = CurrentLoggedInUser;

            LocalStorage.set("_CurrentLoggedInUser", _CurrentLoggedInUser);
            _UserToken = token;
            LocalStorage.set("_UserToken", _UserToken);


            axios.defaults.headers.common.authheader = _UserToken;
            axios.defaults.headers.common['Content-Type'] = 'application/json';

            tokenRenewalService.start(_UserToken, {
                onRenewed: (renewedToken) => this.SetCurrentLoggedInUser(renewedToken),
                onUnauthorized: this.clearStorage,
            });
        };

        const storedToken = LocalStorage.get("_UserToken");
        if (storedToken) {
            _UserToken = storedToken;
            axios.defaults.headers.common.authheader = _UserToken;
            tokenRenewalService.start(_UserToken, {
                onRenewed: (renewedToken) => this.SetCurrentLoggedInUser(renewedToken),
                onUnauthorized: this.clearStorage,
            });
        }

    }
}

export default new AppCache();
